import Vue from "vue";
import Vuex from "vuex";
import $http from "../utils/http";
import Login from "../components/Login";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: localStorage.getItem("whhl_token") || "",
        // userinfo: null,
        // specialtyList: '',
        // copyrightInfo: '',
        // examType: '',
        // examResult: '',
        // searchKeywords: '',
        // buyInfo: '',
        yh: [],
        LoginUserInfo: {}, // 登录的个人信息
        historylist: [], // 文章发布的搜索列表历史
        LocationCity: "", // 定位当前城市
        customerInfo: JSON.parse(localStorage.getItem("customerInfo")) || {}, // 用户积分信息
        hotelHistory: [], // 酒店浏览历史
        scenicHistory: [], // 景区浏览历史
        travelHistory: [], // 旅游浏览历史
        isLogin: false, // 是否登录
        guanJian:'',//酒店搜索关键字
    },
    getters: {
        // userinfo: state => {
        //   let userinfo = state.userinfo || localStorage.getItem('wzjy_userinfo');
        //   if (userinfo) return JSON.parse(userinfo);
        //   else return userinfo;
        // },
        token: state => {
            return state.token;
        },
        yh: state => {
            return state.yh || localStorage.getItem("yha");
        },
        getLoginUserInfo(state) {
            if (state.LoginUserInfo.avatar) {
                return state.LoginUserInfo;
            } else if (
                JSON.parse(localStorage.getItem("LoginUserInfo")).avatar
            ) {
                return JSON.parse(localStorage.getItem("LoginUserInfo"));
            }
            // return state.LoginUserInfo || JSON.parse(localStorage.getItem('LoginUserInfo')) ;
        },
        // 获取文章发布搜索历史
        getHistorylist: state => {
            return localStorage.getItem("historylist");
        },
        // 获取定位城市
        getLocationCity: state => {
            return state.LocationCity || sessionStorage.getItem("LocationCity");
        },
        // specialtyList(state) {
        //   let specialtyList = state.specialtyList || sessionStorage.getItem('wzjy_specialty_list');
        //   if (specialtyList) return JSON.parse(specialtyList);
        //   else return specialtyList;
        // },
        // copyrightInfo(state) {
        //   let copyrightInfo = state.copyrightInfo || sessionStorage.getItem('wzjy_copyright_info');
        //   if (copyrightInfo) return JSON.parse(copyrightInfo);
        //   else return copyrightInfo;
        // },
        // examType(state) {
        //   let examType = state.examType || sessionStorage.getItem('wzjy_exam_type');
        //   if (examType) return JSON.parse(examType);
        //   else return examType;
        // },
        // examResult(state) {
        //   let examResult = state.examResult || sessionStorage.getItem('wzjy_exam_result');
        //   if (examResult) return JSON.parse(examResult);
        //   else return examResult;
        // },
        // searchKeywords(state) {
        //   return state.searchKeywords;
        // },
        // buyInfo(state) {
        //   let buyInfo = state.buyInfo || sessionStorage.getItem('wzjy_buy_info');
        //   if (buyInfo) return JSON.parse(buyInfo);
        //   else return buyInfo;
        // },
        // 获取用户积分信息
        getCustomerInfo(state) {
            return (
                state.customerInfo ||
                JSON.parse(localStorage.getItem("customerInfo"))
            );
        },
        // 获取酒店浏览历史
        getHotelHistory: state => {
            return (
                state.hotelHistory ||
                JSON.parse(localStorage.getItem("hotelHistory"))
            );
        },
        // 获取景区浏览历史
        getScenicHistory: state => {
            return (
                state.scenicHistory ||
                JSON.parse(localStorage.getItem("scenicHistory"))
            );
        },
        // 获取旅游浏览历史
        getTravelHistory: state => {
            return (
                state.travelHistory ||
                JSON.parse(localStorage.getItem("travelHistory"))
            );
        },
        // 获取是否登录
        getIsLogin: state => {
            return state.isLogin;
      },
        // 获取关键字
      getGuanjian: state => { 
          return state.guanJian || localStorage.getItem("guanJian")
      }
    },

    mutations: {
        TOKEN(state, val) {
            localStorage.setItem("whhl_token", val);
            state.token = val;
        },
        YH(state, val) {
            localStorage.setItem("yha", val);
            state.yh = val;
        },
        // 删除token
        delToken(state, val) {
            localStorage.removeItem("whhl_token");
            state.token = "";
        },
        // 设置登录时userInfo
        setLoginUserInfo(state, val) {
            localStorage.setItem("LoginUserInfo", JSON.stringify(val));
            state.LoginUserInfo = val;
        },
        delLoginUserinfo(state, val) {
            localStorage.removeItem("LoginUserInfo");
            state.LoginUserInfo = {};
        },
        // 更新文章发布的历史
        upHistorylist(state, val) {
            state.historylist = val;
            localStorage.setItem("historylist", JSON.stringify(val));
        },
        // 删除文章发布的历史
        delHistorylist(state) {
            state.historylist = "";
            localStorage.removeItem("historylist");
        },
        // 更新定位城市
        upLocationCity(state, val) {
            state.LocationCity = val;
            sessionStorage.setItem("LocationCity", val);
        },
        // 删除定位城市
        delLocationCity(state) {
            state.LocationCity = "";
            sessionStorage.removeItem("LocationCity");
        },
        // 更新用户积分信息
        upCustomerInfo(state, data) {
            localStorage.setItem("customerInfo", JSON.stringify(data));
            state.customerInfo = data;
        },
        // 更新酒店搜索
        upHotelHistory(state, val) {
            let a = state.hotelHistory.every(item => {
                return item.hotelId !== val.hotelId;
            });
            if (a) {
                state.hotelHistory.unshift(val);
            }
            if (state.hotelHistory.length > 2) {
                state.hotelHistory.pop();
            }
            localStorage.setItem(
                "hotelHistory",
                JSON.stringify(state.hotelHistory)
            );
        },
        // 更新景区搜索
        upScenicHistory(state, val) {
            let a = state.scenicHistory.every(item => {
                return item.jqId !== val.jqId;
            });
            if (a) {
                state.scenicHistory.unshift(val);
            }
            if (state.scenicHistory.length > 2) {
                state.scenicHistory.pop();
            }
            localStorage.setItem(
                "scenicHistory",
                JSON.stringify(state.scenicHistory)
            );
        },
        // 更新景区搜索
        upTravelHistory(state, val) {
            let a = state.travelHistory.every(item => {
                return item.id !== val.id;
            });
            if (a) {
                state.travelHistory.unshift(val);
            }
            if (state.travelHistory.length > 2) {
                state.travelHistory.pop();
            }
            localStorage.setItem(
                "travelHistory",
                JSON.stringify(state.travelHistory)
            );
        },
        // 更新景区搜索
        upIsLogin(state, val) {
            state.isLogin = val;
            sessionStorage.setItem("isLogin", val);
      },
        // 更新搜索关键字
        upguanJian(state, val) {
          state.guanJian = val;
          localStorage.setItem("guanJian", val);
      },
      // 删除搜索关键字
      delguanJian(state) {
          state.guanJian = "";
          localStorage.removeItem("guanJian");
      },
    },
    actions: {
        setToken({ commit }, val) {
            commit("TOKEN", val);
        },
        setYH({ commit }, val) {
            commit("YH", val);
        },
        getUserStatus() {
            return new Promise((resolve, reject) => {
                $http.get("/customer/authInfo").then(res => {
                    resolve(res);
                });
            });
        },
        //个人信息
        upcustomerInfo(context, data) {
            context.commit("upCustomerInfo", data);
        }
    },
    modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js